import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as FreudDS from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SpeechToTextModule } from 'modules/promptuary/components/speech-to-text/speech-to-text.module';
import { TooltipModule } from 'primeng/tooltip';
import { ContactInfo } from 'shared/components/contact-info/contact-info.component';

import { ServiceEvolutionQualityBannerModule } from '../modules/promptuary/components/service-evolution-quality-banner/service-evolution-quality-banner.module';
import { AutosaveTextarea } from './components/autosave-textarea/autosave-textarea.component';
import { ModalSidebarModule } from './components/modal-sidebar/modal-sidebar.module';

/**
 * This module is intended for components and services shared by the application until the upgrade to Angular 14, where we will have standalone components out of the box.
 */

@NgModule({
	declarations: [AutosaveTextarea, ContactInfo],
	exports: [AutosaveTextarea, ContactInfo],
	imports: [
		CommonModule,
		FreudDS.FreudLoaderModule,
		FreudDS.FreudTagModule,
		TooltipModule,
		TranslateModule.forChild(),
		ModalSidebarModule,
		FreudDS.FreudTooltipModule,
		FormsModule,
		SpeechToTextModule,
		ServiceEvolutionQualityBannerModule,
	],
})
export class SharedModule {}
